"use client";

import { Input } from "@/components/ui/input";

export function FilterNumberInput({
  value,
  onChange,
  min = 0,
  max = 99,
  placeholder = "0",
  "aria-label": ariaLabel,
}: {
  value: number | undefined;
  onChange: (v: number | undefined) => void;
  min?: number;
  max?: number;
  placeholder?: string;
  "aria-label"?: string;
}) {
  return (
    <Input
      type="text"
      variant="filter"
      inputMode="numeric"
      pattern="[0-9]*"
      value={value ?? ""}
      placeholder={placeholder}
      aria-label={ariaLabel}
      onChange={(e) => {
        const raw = e.target.value.replace(/\D/g, "");
        if (raw === "") {
          onChange(undefined);
          return;
        }
        const n = Math.min(max, Math.max(min, Number(raw)));
        onChange(n);
      }}
    />
  );
}
